"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BoxVisibilityOptions = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BoxVisibility = function BoxVisibility(_ref) {
  var xs = _ref.xs,
      sm = _ref.sm,
      md = _ref.md,
      children = _ref.children;
  return /*#__PURE__*/_react.default.createElement(_core.Box, {
    display: {
      xs: xs,
      sm: sm,
      md: md
    }
  }, children);
};

BoxVisibility.propTypes = {
  xs: _propTypes.default.oneOf(["block", "none"]),
  sm: _propTypes.default.oneOf(["block", "none"]),
  md: _propTypes.default.oneOf(["block", "none"]),
  children: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.node])
};
BoxVisibility.defaultProps = {
  xs: "none",
  sm: "none",
  md: "none",
  children: null
};
var BoxVisibilityOptions = ["block", "none"];
exports.BoxVisibilityOptions = BoxVisibilityOptions;
var _default = BoxVisibility;
exports.default = _default;